import request from "../clientsApi";
import { API_ROUTES } from "../../config/baseURL";

export const apiGetExcludedQuestionsBySubgroup = async (grupo = "", subgrupo = "") => {
  const res = await request(API_ROUTES.getExcludedQuestionsBySubgroup(grupo, subgrupo), {
    method: "GET",
  });

  return res.json();
};

export const apiGetAvailableExcludedQuestions = async () => {
  const res = await request(API_ROUTES.getAvailableExcludedQuestions, {
    method: "GET",
  });

  return res.json();
};

export const apiSaveExcludedQuestionsBySubgroup = async (payload) => {
  const res = await request(API_ROUTES.saveExcludedQuestionsBySubgroup, {
    method: "POST",
    body: JSON.stringify(payload),
  });

  return res.json();
};

export const apiDeleteExcludedQuestionBySubgroup = async (payload) => {
  const res = await request(API_ROUTES.deleteExcludedQuestionBySubgroup, {
    method: "POST",
    body: JSON.stringify(payload),
  });

  return res.json();
};
